import React from "react";

// Local Imports
import NOMothersDayBanner from "../../images/graphic_design/Night_Owl_Mothers_Day_Sale_Banner.jpg";

// Font Awesome Imports
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearchPlus } from "@fortawesome/free-solid-svg-icons";

// React PopUpBox
import { PopupboxContainer, PopupboxManager } from "react-popupbox";
import "react-popupbox/dist/react-popupbox.css";

function GD_Project_2() {
  // Night Owl Mothers Day Sale Facebook Banner
  const openPopupBoxNOMothersDaySaleBanner = () => {
    const content = (
      <>
        <div className="image-center">
          <img
            className="portfolio-image-popupbox"
            src={NOMothersDayBanner}
            alt="Screenshot of Night Owl Mothers Day Sale Facebook Banner"
          />
        </div>
        <p>A generic sale Facebook cover banner regarding Mother's Day</p>
        <ul>
          <li>Selected imagery from stock imagery websites</li>
          <li>Added graphics and typography</li>
          <li>Utilized product placement of a wired 1080p camera</li>
        </ul>
      </>
    );
    PopupboxManager.open({ content });
    PopupboxManager.update({
      content,
      config: {
        titleBar: {
          text: "Night Owl | Mother's Day Sale | Facebook Banner",
        },
      },
    });
  };

  const popupboxConfigNOMothersDaySaleBanner = {
    titleBar: {
      enable: true,
      text: "Night Owl | Mother's Day Sale | Facebook Banner",
    },
    fadeIn: true,
    fadeInSpeed: 500,
  };

  return (
    <>
      <div
        className="portfolio-image-box"
        onClick={openPopupBoxNOMothersDaySaleBanner}
      >
        <img
          className="portfolio-image constraints"
          src={NOMothersDayBanner}
          alt="Screenshot of Night Owl Mothers Day Sale Facebook Banner"
        />
        <div className="overflow"></div>
        <FontAwesomeIcon className="portfolio-icon" icon={faSearchPlus} />
      </div>
      <PopupboxContainer {...popupboxConfigNOMothersDaySaleBanner} />
    </>
  );
}

export default GD_Project_2;
